import { bridge } from '../../../features/extensions/instances';
import {
  useExtensionsSetupRegistry,
  useExtensionsAddPageApplet,
  useExtensionsAddTranscription,
  useExtensionsTrackingPageVisited,
  useExtensionsAppToken,
  useExtensionsFileTransfer,
  useExtensionsPhotoCapture,
  useExtensionsFeatureFlag,
  useExtensionsSideloading,
} from '../../../hooks/useExtensions';

export function ExtensionsMainProvider(): null {
  // Sideloading adds extensions directly to the bridge with source='sideload'
  // Registry detects sideloaded extensions by source and excludes them automatically
  useExtensionsSideloading();
  useExtensionsSetupRegistry();

  // provider specific init capabilities
  useExtensionsAddPageApplet();
  useExtensionsAddTranscription();
  useExtensionsAppToken(bridge);
  useExtensionsFileTransfer();
  useExtensionsPhotoCapture();
  useExtensionsFeatureFlag();

  // tracking
  useExtensionsTrackingPageVisited();
  return null;
}
